export const academicCV = {
  id: 'academic-cv',
  version: 2,
  renderer: 'enterprise',
  name: 'Academic CV Professional',
  layout: 'single-column',
  theme: 'classic-navy',
  persona: ['research'],
  atsLevel: 'A+',
  scoreWeights: {
    ats: 50,
    visual: 10,
    executive: 20,
    student: 20
  },
  sectionOrder: ['personal-info', 'education', 'experience', 'projects', 'skills', 'certifications'],
  components: {
    header: 'header-centered',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-classic'
  },
  metadata: {
    industry: ['Higher Education', 'University Administration', 'Secondary Education'],
    companies: ['Harvard', 'Stanford', 'Oxford', 'Yale', 'Cambridge', 'UC Berkeley'],
    ats: ['Workday', 'Taleo'],
    pages: { min: 2, max: 15, preferred: 4 },
    photo: false,
    icons: false,
    columns: 1,
    experienceLevel: ['PhD Candidate', 'Postdoc', 'Professor', 'Lecturer'],
    careerStage: 'Academic',
    recommendedFor: ['Professors', 'Lecturers', 'Academic Researchers', 'Postdoctoral Fellows'],
    avoidFor: ['Creative Directors', 'Software Engineers', 'Product Managers'],
    dna: ['Academic-Elite', 'Publications-Dense', 'Georgia-Classic', 'Traditional-Serif', 'Multi-Page'],
    metrics: {
      readingDifficulty: 99,
      scanningSpeed: 89,
      visualAppeal: 77
    },
    hiringManager: {
      firstImpression: "Highly academic, thorough, credentialed university educator/scholar",
      scanningStyle: "Linear scanning focusing on teaching history, publications, grants, and advising",
      preferredStructure: "Education, experience, publications, teaching, advising, skills",
      dislikes: ["Creative highlights", "Icons", "Objective summaries", "Visual charts or scales"]
    },
    strategy: {
      goal: "Pass academic committee screening and project classical academic credibility",
      focus: "University teaching experience, academic journal publications, research grants",
      avoid: ["Gimmicky design elements", "Sidebar structures"]
    },
    psychology: {
      coreTraits: ["Academic excellence", "Pedagogical rigor", "Intellectual depth", "Institutional alignment"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Focus on teaching methodologies, student mentorship, peer-reviewed publications, and university service. Use formal academic vocabulary.",
      rewriteStyle: "Formal, academic, classical-scholar"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.4,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: true,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['education', 'experience', 'projects', 'skills', 'certifications']
      },
      overrides: {
        '--font-family-primary': 'Georgia, serif',
        '--spacing-margin': '24px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--heading-weight': '800',
    '--border-thickness-heading': '2.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '14px',
    '--spacing-bullet-gap': '6px',
    '--color-text-main': '#2F2F2F',
    '--color-text-light': '#777777'
  }
};
export default academicCV;
